<template>
  <div class="datepicker">
    <input type="text" class="inp_date" ref="input" :value="selectedDateText" :style="{width}" readonly>

    <div v-show="buttonContainerView" class="datepicker_container" :class="buttonContainerClass">
      <div class="datepicker_header">
        <a class="prev" @click="tickCurrentYear(-1)" title="이전 해" :class="{'disabled': prevYearDisabled}">
          <span class="ico">이전 해</span>
        </a>
        <a class="next" @click="tickCurrentYear(1)" title="다음 해" :class="{'disabled': nextYearDisabled}">
          <span class="ico">다음 해</span>
        </a>
        <div class="title">{{currentYear}}년</div>
      </div>

      <table class="datepicker_calendar">
        <tbody>
          <tr v-for="(item, index) in monthDiv" :key="index">
            <td v-for="(sItem, index) in item" :key="index">
              <a class="default" href="#" :class="buttonClass(sItem)" @click.prevent="onClickMonth(sItem)">{{sItem.month + 1}}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import toggleContainer from '$mixins/toggleContainer'
import datepicker from '$mixins/datepicker'

export default {
  mixins: [ toggleContainer, datepicker ],
  props: {
    width: {
      type: String,
    },
    format: {
      type: String,
      default: 'yyyy-mm'
    },
  },
  data() {
    return {
      buttonContainerClass: 'monthly',
      selectedDate: this.value,
    }
  },
  watch: {
    selectedDate() {
      this.toggleButtonContainer(false)
    },
    buttonContainerView() {
      this.syncCurrentAndSelected()
    }
  },
  computed: {
    monthDiv() {
      return _.chunk(_.times(12, month => {
        const isSelectedYear = this.selectedDate.getFullYear() === this.currentYear
        const selectedQuarter = Math.floor(this.selectedDate.getMonth() / 3) + 1
        return {
          month,
          date: new Date(this.currentYear, month),
          disabled: !this.selectableMonthList.includes(month),
          selected: isSelectedYear && this.selectedDate.getMonth() === month,
          selectedQuarter: isSelectedYear && selectedQuarter === Math.floor(month / 3) + 1
        }
      }), 3)
    },
    selectedDateText() {
      return this.$utils.dateformat(this.selectedDate, this.format)
    },
    selectedStartDate() {
      return new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth())
    },
    selectedEndDate() {
      const endDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth())
      endDate.setMonth(endDate.getMonth() + 1)
      endDate.setDate(endDate.getDate() - 1)
      endDate.setHours(23, 59, 59, 999)
      return endDate
    }
  },
  methods: {
    onClickMonth(item) {
      if (item.disabled) return
      this.selectedDate = item.date
      this.buttonContainerView = false
    },
    buttonClass(item) {
      return {
        active: item.selected,
        disabled: item.disabled
      }
    },
    // 시작일 리턴
    getDate() {
      return this.getData().startDate
    },
    getData() {
      return {
        value: this.selectedDateText,
        startDate: new Date(this.selectedStartDate),
        endDate: new Date(this.selectedEndDate)
      }
    },
  }
}
</script>
